import { Component, Input, ViewEncapsulation } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import {
	ICGIOption,
	QuestionType,
} from 'modules/promptuary/interfaces/cgi.interface';

@Component({
	selector: 'cgi-severity',
	templateUrl: './cgi-severity.component.html',
	styleUrls: ['./cgi-severity.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CGISeverity {
	@Input()
	severity: ICGIOption;

	@Input()
	type: QuestionType;

	@Input()
	mode: 'promptuary' | 'vc' | 'appointment';

	constructor(public actionTrackerService: ActionTrackerService) {}

	trackTooltip(): void {
		let scopeType = SCOPE_TYPE.VideoConference;

		if (this.mode === 'promptuary') {
			scopeType = SCOPE_TYPE.Promptuary;
		}

		if (this.mode === 'appointment') {
			scopeType = SCOPE_TYPE.Appointment;
		}

		this.actionTrackerService.eventTracker(
			scopeType,
			SUBSCOPE_TYPE.Cgi,
			ITEM_TYPE.ToolTip,
			INTERACTION_TYPE.Seen
		);
	}
}
